// ─── src/api/newsletter.ts ────────────────────────────────────────────────────

import { apiClient } from "./registration";
import type { NewsletterParams, NewsletterResponse, NewsletterSubscriber } from "../types/newsletter";
import type { PaginationMeta } from "../types/registration";

export interface NormalisedNewsletterResponse {
  data: NewsletterSubscriber[];
  meta: PaginationMeta;
}

const normalise = (raw: NewsletterResponse): NormalisedNewsletterResponse => ({
  data: raw.data,
  meta: {
    total:      raw.total,
    page:       raw.page,
    limit:      raw.limit,
    totalPages: Math.ceil(raw.total / raw.limit),
  },
});

export const getNewsletterSubscribers = async (
  params: NewsletterParams,
): Promise<NormalisedNewsletterResponse> => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null),
  );
  const { data } = await apiClient.get<NewsletterResponse>("/newsletter", {
    params: cleanParams,
  });
  return normalise(data);
};

export const deleteNewsletterSubscriber = async (id: string): Promise<void> => {
  await apiClient.delete(`/newsletter/${id}`);
};
